import React, {useState, useEffect } from 'react';
import { Modal, Button, Form, Col, Row } from 'react-bootstrap';

const RuleModal = ({ show, onHide, onSave, rule }) => {
  const [formData, setFormData] = useState({ logic: { type: 'transaction' } });

  useEffect(() => {
    const initialLogic = rule?.logic || { type: 'transaction', field: 'amount', operator: '>', value: 10000, txnType: 'Cash Deposit' };
    setFormData(rule ? { ...rule } : { 
        name: '', description: '', 
        riskScore: 50, autoCreateCase: false, 
        logic: initialLogic 
    });
  }, [rule]);

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleCheckboxChange = e => setFormData({ ...formData, [e.target.name]: e.target.checked });

  const handleLogicTypeChange = (e) => {
    const type = e.target.value;
    let newLogic = { type };
    if (type === 'transaction') {
        newLogic = { ...newLogic, field: 'amount', operator: '>', value: 10000, txnType: 'Cash Deposit' };
    } else { // kyc
        newLogic = { ...newLogic, field: 'riskRating', operator: '===', value: 'High' };
    }
    setFormData({ ...formData, logic: newLogic });
  };

  const handleLogicChange = e => {
    const { name, value } = e.target;
    let val = value;
    if (name === 'value' && formData.logic.field === 'amount') {
        val = parseInt(value, 10);
    }
    setFormData({ ...formData, logic: { ...formData.logic, [name]: val } });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton><Modal.Title>{rule ? 'Edit Rule in Sandbox' : 'Create New Rule'}</Modal.Title></Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <h5>Rule Details</h5>
          <Row>
            <Col md={12}><Form.Group className="mb-3"><Form.Label>Rule Name</Form.Label><Form.Control type="text" name="name" value={formData.name || ''} onChange={handleChange} required /></Form.Group></Col>
            <Col md={12}><Form.Group className="mb-3"><Form.Label>Description</Form.Label><Form.Control as="textarea" rows={2} name="description" value={formData.description || ''} onChange={handleChange} required /></Form.Group></Col>
          </Row>
          <hr />
          <h5>Rule Logic & Behavior</h5>
          <Form.Group className="mb-3">
            <Form.Label><strong>Rule Type</strong></Form.Label>
            <Form.Select value={formData.logic.type} onChange={handleLogicTypeChange}>
                <option value="transaction">Transaction-Based (Behavioral)</option>
                <option value="kyc">KYC-Based (Profile Data)</option>
            </Form.Select>
          </Form.Group>

          {/* Conditional UI for Transaction Rules */}
          {formData.logic.type === 'transaction' && (
            <Row className="p-2 border rounded">
                <Col md={4}><Form.Group><Form.Label>Transaction Type</Form.Label><Form.Select name="txnType" value={formData.logic.txnType || ''} onChange={handleLogicChange}>
                    <option>Cash Deposit</option><option>Wire Transfer</option>
                </Form.Select></Form.Group></Col>
                <Col md={3}><Form.Group><Form.Label>Field</Form.Label><Form.Select name="field" value={formData.logic.field || ''} onChange={handleLogicChange}>
                    <option value="amount">Amount</option><option value="counterpartyCountry">Counterparty Country</option>
                </Form.Select></Form.Group></Col>
                <Col md={2}><Form.Group><Form.Label>Operator</Form.Label><Form.Select name="operator" value={formData.logic.operator || ''} onChange={handleLogicChange}>
                    <option>&gt;</option><option>&lt;</option>
                </Form.Select></Form.Group></Col>
                <Col md={3}><Form.Group><Form.Label>Value</Form.Label><Form.Control type="number" name="value" value={formData.logic.value || ''} onChange={handleLogicChange} /></Form.Group></Col>
            </Row>
          )}

          {/* Conditional UI for KYC Rules */}
          {formData.logic.type === 'kyc' && (
            <Row className="p-2 border rounded">
                <Col md={4}><Form.Group><Form.Label>KYC Field</Form.Label><Form.Select name="field" value={formData.logic.field || ''} onChange={handleLogicChange}>
                    <option value="riskRating">Risk Rating</option><option value="watchlistTag">Watchlist Tag</option><option value="tags">User-Defined Tags</option>
                </Form.Select></Form.Group></Col>
                <Col md={3}><Form.Group><Form.Label>Operator</Form.Label><Form.Select name="operator" value={formData.logic.operator || ''} onChange={handleLogicChange}>
                    <option value="===">Equals</option><option value="!==">Not Equals</option><option value="contains">Contains</option>
                </Form.Select></Form.Group></Col>
                <Col md={5}><Form.Group><Form.Label>Value</Form.Label><Form.Control type="text" name="value" value={formData.logic.value || ''} onChange={handleLogicChange} /></Form.Group></Col>
            </Row>
          )}
          <hr />
          <h5>Automation & Scoring</h5>
          <Row>
             <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Alert Risk Score (1-100)</Form.Label>
                    <Form.Control type="number" name="riskScore" min="1" max="100" value={formData.riskScore || ''} onChange={handleChange} required />
                </Form.Group>
            </Col>
            <Col md={6} className="d-flex align-items-center">
                <Form.Group className="mt-3">
                    <Form.Check type="switch" id="auto-create-case" label="Auto-Create Case for this Alert?" name="autoCreateCase" checked={formData.autoCreateCase || false} onChange={handleCheckboxChange} />
                </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button variant="primary" type="submit">Save Rule to Sandbox</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RuleModal;